/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * ConfirmUpdateEosInfo — Confirmation dialog for refreshing country info.
 * Migrated from: lego/page/eos/transfer-media/ConfirmUpdateEosInfo.jsx
 */

import { useState } from 'react'
import { useServiceContext } from '../../../root'
import Modal from '../../../components/Modal'
import type { ConfirmUpdateEosInfoProps } from './types'

const ConfirmUpdateEosInfo: React.FC<ConfirmUpdateEosInfoProps> = ({ ftpConfig, isPdrFlow }) => {
  const [isOpen, setIsOpen] = useState(true)
  const context = useServiceContext()
  const { translate } = context.service.filter

  const doClose = () => {
    setIsOpen(false)
  }

  const updateEosInfo = () => {
    context.api.eos.updateCountryInfo(ftpConfig.studyFolderId!, ftpConfig.mccEnabled!).then(
      () => {
        context.service.toast.success('EOS_TRANSFER_MEDIA_STUDY_DETAILS_REFRESH_SUCCESS_MSG')
        doClose()
      },
      (data: { data?: { message?: string } }) => {
        context.service.toast.error(data?.data?.message ?? 'ERROR')
        doClose()
      }
    )
  }

  return (
    <Modal
      show={isOpen}
      handleClose={doClose}
      title={translate('CONFIRMATION')}
      isLevelTwoModal
      className="level-one-modal"
    >
      <Modal.Body>
        <p>
          {translate(
            isPdrFlow
              ? 'PDR_TRANSFER_MEDIA_STUDY_DETAILS_REFRESH_CONFIRMATION_INFO'
              : 'EOS_TRANSFER_MEDIA_STUDY_DETAILS_REFRESH_CONFIRMATION_INFO'
          )}
          <br />
          <br />
          <b>{translate('EOS_TRANSFER_MEDIA_STUDY_DETAILS_REFRESH_CONFIRMATION_QUESTION')}</b>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Button variant="link" onClick={doClose}>
          {translate('NO')}
        </Modal.Footer.Button>
        <Modal.Footer.Button variant="primary" onClick={updateEosInfo}>
          {translate('YES')}
        </Modal.Footer.Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmUpdateEosInfo
